"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LvFalconNavigator_1 = require("./LvFalconNavigator");
var LvAnnualNBNavigator = /** @class */ (function (_super) {
    __extends(LvAnnualNBNavigator, _super);
    function LvAnnualNBNavigator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LvAnnualNBNavigator.prototype.renderBackButton = function () {
        if (!this.props.page) {
            return null;
        }
        if (this.props.page.prevPage) {
            return ((0, jsx_runtime_1.jsx)("button", { type: "button", role: "link", className: "btn btn-back btn-back-wolf-nb", onMouseDown: this.skipDefault, onTouchStart: this.skipDefault, onClick: this.clickPrev, id: "navigatorBack", children: this.props.page && this.props.page.prevPageLabel ? this.props.page.prevPageLabel : "Back" }));
        }
        return null;
    };
    return LvAnnualNBNavigator;
}(LvFalconNavigator_1.default));
exports.default = LvAnnualNBNavigator;
//# sourceMappingURL=LvAnnualNBNavigator.js.map